var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{attrs:{"fluid":"","align":"center"}},[_c('p',[_vm._v("Invalid access on Order, you're being redirected ...")])])
}
var staticRenderFns = []

export { render, staticRenderFns }